import { createContext } from 'react';

interface I18nContext {
  locale: string;
}

const i18nContext = createContext<I18nContext | null>(null);

export default i18nContext;
